import React from 'react';
import { isEmpty } from 'lodash';
import { AnimatePresence, motion } from 'framer-motion';
import Link from '../layouts/Link';
import LockBody from '../layouts/LockBody';
import BoxedContainer from '../layouts/BoxedContainer';

export default function MobileHeaderMenu({ data, isOpen }) {
  return (
    <AnimatePresence>
      {isOpen && (
        <BoxedContainer>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3, type: 'tween', ease: 'easeInOut' }}
            className="fixed bg-red top-0 left-0 w-full h-screen pt-[140px] pb-[100px] z-5 px-4">
            <LockBody />
            <div className="flex flex-col justify-between max-w-[375px] mx-auto">
              <div className="flex justify-between gap-y-6">
                {isEmpty(data) ||
                  data.map(({ content }, index) => (
                    <div key={index} className="flex flex-col gap-y-4">
                      {/* {console.log(content)} */}
                      {isEmpty(content.urls) ||
                        content.urls.map((item, index2) => (
                          <Link
                            key={index2}
                            to={item.url}
                            className="text-white font-roboto-condensed-bold text-[18px] uppercase
                            leading-[24px] whitespace-pre transition-all duration-300
                            hover:opacity-50">
                            {item.name}
                          </Link>
                        ))}
                    </div>
                  ))}
              </div>
            </div>
          </motion.div>
        </BoxedContainer>
      )}
    </AnimatePresence>
  );
}
